var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "home-fill 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.23134 21H5.91791C4.57463 21 3.5 19.9227 3.5 18.5761V10.1372C3.5 9.05985 4.03731 7.98254 5.02239 7.35412L11.2015 3.40399C12.0075 2.86534 12.9925 2.86534 13.7985 3.40399L19.9776 7.35412C20.8731 7.98254 21.5 8.97007 21.5 10.1372V18.5761C21.5 19.9227 20.4254 21 19.0821 21H15.8582H9.23134Z",
    stroke: "#D1D1D1",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.1719ce51ed600f48003ddc20c728048d.svg";
export { ForwardRef as ReactComponent };